export const users = {
  profile: {
    title: 'My Profile',
    personalInfo: 'Personal Information',
    securitySettings: 'Security Settings',
    activityHistory: 'Activity History',
    memberSince: 'Member Since',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    updatePassword: 'Update Password',
    passwordRequired: 'All password fields are required',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordUpdated: 'Password updated successfully',
    passwordUpdateFailed: 'Failed to update password',
    twoFactorAuth: 'Two-Factor Authentication',
    enable2fa: 'Enable 2FA',
    disable2fa: 'Disable 2FA',
    '2faEnabledText': 'Two-factor authentication is enabled',
    '2faDisabledText': 'Two-factor authentication is disabled',
    '2faEnabled': 'Two-factor authentication enabled',
    '2faDisabled': 'Two-factor authentication disabled',
    '2faToggleFailed': 'Failed to toggle two-factor authentication',
    setup2fa: 'Set Up Two-Factor Authentication',
    '2faInstructions': 'Scan this QR code with your authenticator app (Google Authenticator, Microsoft Authenticator, etc.)',
    manualEntry: 'Or enter this code manually',
    verificationCode: 'Verification Code',
    verifyAndEnable: 'Verify & Enable',
    '2faSetupFailed': 'Failed to set up two-factor authentication',
    '2faCodeRequired': 'Please enter a 6-digit verification code',
    '2faVerifyFailed': 'Failed to verify code. Please try again.',
    disable2faWarning: 'Disabling two-factor authentication will make your account less secure.',
    enterPasswordToDisable: 'Enter your password to confirm:',
    '2faDisableFailed': 'Failed to disable two-factor authentication',
    noActivity: 'No recent activity',
  },
};